import { useState } from "react";
import "../../App.css";

export default function RegisterChat({ register }) {
  const [inputText, setInputText] = useState("");
  const [file, setFile] = useState(null);
  const [profileUrl, setProfileUrl] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleUpload() {
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      setLoading(true);

      const res = await fetch(process.env.REACT_APP_API_UPLOAD_URL, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
console.log(`handleUpload resposta: ${res}`);
console.log(`data.file.url : ${data.file.url}`);

      setProfileUrl(data.file.url);
    } catch (err) {
      console.error("Erro no upload:", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="register-container">
      <div className="register-card">
        <h2>Registrar</h2>

        <input
          className="input"
          placeholder="Digite seu nome"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
        />

        <input
          type="file"
          accept="image/*"
          onChange={(e) => setFile(e.target.files?.[0])}
        />

        <button className="upload-btn" onClick={handleUpload}>
          {loading ? "Enviando..." : "Upload da Foto"}
        </button>

        {profileUrl && (
          <img className="preview" src={profileUrl} alt="preview" />
        )}

        <button
          className="register-btn"
          onClick={() => {
            register(inputText, profileUrl);
            setInputText("");
            setProfileUrl("");
          }}
        >
          Register
        </button>
      </div>
    </div>
  );
}
